/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import classnames from 'classnames';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import SimpleRouteDetail from 'app/components/RouteList/SimpleRouteItemDetail.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ListModule from 'app/mixins/ListModule.js';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import { Breakpoint } from 'react-socks';

class SimpleRouteItem extends React.Component {
	constructor(props) {
		super(props);

		this.listRowRef = React.createRef();
	}

	componentDidMount() {

        if (this.props.showDetail) {
			let element = document.getElementById(`route-${this.props.route.id}`);
			if (element) {
				let pos = element.getBoundingClientRect().top;
				window.scrollTo({
					top: (pos + window.pageYOffset) - 125,
					behavior: "instant"
				});
			}
        }

    }

	render() {
		let InputIcon = null,
			status = null,
			statusClass = "",
			inactive = (parseInt(this.props.route.activeFlag, 10) === 1) ? false : true,
			RouteDetail = null,
			OutputIcons = null,
			countLabel = null,
			code = '',
			itemClass = '',
			dividerType = 'icon ion-forward',
			itemNameClass = '',
			dividerClass = '',
			socialLabelClass = '',
			itemStatusClass = '',
			constants = this.props.app.config.constants,
			iconInactive = false,
			accordionOpen = false,
			dashed = false;

		if (this.props.route.inputs.length) {
			if (this.props.route.inputs[0].subtype) {
				code = this.props.route.inputs[0].subtype;
			} else {
				code = this.props.route.inputs[0].type;
			}
			InputIcon = IconFactory[ConstantMixin.getIconIndexByCode(code)];

			// if the input isn't active or sysActionFlag has been set, set the route to inactive
			if (this.props.route.inputs[0].activeFlag === false ||
				this.props.route.inputs[0].sysActionFlag === true) {
				inactive = true;
			}

		} else {
			// No inputs? This is not a simple route or the route hasn't been loaded, return null and move on
			return null;
		}

		// work out the class names
		itemClass = classnames(
			'dlvr-list-item',
			'simple',
			{
				'detail': (this.props.showDetail) ? true : false,
				'inactive': inactive,
				'blur': (this.props.showDetail && this.props.routeDetail === null) ? true : false
			}
		);

		itemNameClass = classnames(
			'item-input-label',
			{
				'inactive': inactive
			}
		);

		if (parseInt(this.props.route.inputs[0].postFlag, 10) === constants.POST_QUEUE) {
			if (parseInt(this.props.route.inputs[0].repostFlag, 10)) {
				dividerType = 'ds-icon icon-replay-queue';
			} else {
				dividerType = 'ds-icon icon-queue';
			}

		} else if (parseInt(this.props.route.inputs[0].repostFlag, 10)) {
			dividerType = 'icon ion-reply-all'
		}
		dividerClass = classnames(
			dividerType,
			{
				'detail': (this.props.showDetail) ? true : false
			}
		);

		socialLabelClass = classnames(
			'item-social-label',
			{
				'inactive': inactive
			}
		);

		itemStatusClass = classnames(
			'item-status-label',
			{
				'inactive': inactive
			}
		);

		OutputIcons = this.props.getOutputIcons(this.props.route.outputs, inactive);

		status = this.props.setStatus(this.props.route.activeFlag, this.props.route.lastPost.postTs);

		statusClass = classnames(
			'item-row-cell status',
			status.className,
			{
				'inactive': inactive
			}
		);

		if (this.props.showDetail) {
			RouteDetail = (
				<SimpleRouteDetail
					{...this.props}
					route={this.props.route}
					newRouteInfo={this.props.newRouteInfo}
					messages={this.props.messages}
					inputRefreshHandler={this.props.inputRefreshHandler}
					errorCount={this.props.route.errCount}
					recordPath={this.props.recordPath} />
			);
			accordionOpen = true;
		}

		return (
			<li className={itemClass} ref={this.listRowRef} id={`route-${this.props.route.id}`}>
				<div className="list-item-row" onClick={this.props.detailHandler} data-id={this.props.route.id} role="button" aria-label={this.props.route.inputs[0].name}>
					<AccordionControl accordionOpen={accordionOpen} />
					<div className="item-row-cell input-label">
						<div className="input-flex-wrapper">
							<div className="item-icon-wrapper">
								<InputIcon round={true} inactive={inactive}/>
							</div>
							<div className={itemNameClass} title={this.props.route.inputs[0].name} alt={this.props.route.inputs[0].name}>
								{this.props.route.inputs[0].name || ''}
							</div>
						</div>
					</div>
					<div className="item-row-cell item-divider">
						<i className={dividerClass}></i>
					</div>
					<Breakpoint desktop only>
						<div className="item-row-cell social">
							{OutputIcons}
						</div>
					</Breakpoint>
					<div className={statusClass}>
						<span className={itemStatusClass}>
							{status.label}
						</span>
						<span className="item-status-icon">
							{status.icon}
						</span>
					</div>
				</div>
				{RouteDetail}
			</li>
		);
	}
}

SimpleRouteItem.propTypes = {
	route: PropTypes.object,
	setModal: PropTypes.func,
	detailHandler: PropTypes.func,
	newRouteInfo: PropTypes.object,
	showDetail: PropTypes.bool,
	recordPath: PropTypes.func
};

SimpleRouteItem.defaultProps = {
	route: {},
	setModal: () => {},
	detailHandler: () => {},
	newRouteInfo: {},
	showDetail: false,
	recordPath: null
};

export default ListModule(SimpleRouteItem);
